import Event from 'eventemitter3';

export default new Event();
